export type FuelEntity = {
  id: number
  name: string
  unit: FuelUnitEnum
  price: number
  type: FuelTypeEnum
}

export enum FuelUnitEnum {
  LITTER = 'LITTER',
}

export enum FuelTypeEnum {
  GASOLINE = 'GASOLINE',
  DIESEL = 'DIESEL',
}

export type FuelFilter = {
  name: string
  units: string[]
  priceFrom?: number
  priceTo?: number
  types: string[]
}
